// extracted by mini-css-extract-plugin
export var closeButton = "_9p-0";